
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Payments from './payments';
import ManageZaggleCard from './ManageZaggleCardsLogin';
import { constants } from '../../devUtils';

class ManageZaggleCards extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { location: { pathname } = {} } = this.props;
    if (pathname === constants.LINK_MANAGE_ZAGGLE_CARD) {
      return <ManageZaggleCard />;
    } else if (pathname === constants.APP_LOGIN || pathname === constants.LINK_HOME || pathname === constants.LYRA_PG_LOGIN) {
      return <Payments />;
    }
    return null;
  }
}

ManageZaggleCards.propTypes = {
  location: PropTypes.shape({}).isRequired,
};

export default ManageZaggleCards;



// WEBPACK FOOTER //
// client/containers/ManageZaggleCard/index.js